import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SimpleDialogDemo from "./components/Badge";

// icons
import MediationIcon from "@mui/icons-material/Mediation";
import StoreIcon from "@mui/icons-material/Store";
import ListAltIcon from "@mui/icons-material/ListAlt";
import GroupIcon from "@mui/icons-material/Group";
import ForumIcon from "@mui/icons-material/Forum";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MenuIcon from "@mui/icons-material/Menu";
import PaymentsIcon from "@mui/icons-material/Payments";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PercentIcon from "@mui/icons-material/Percent";
import BookIcon from "@mui/icons-material/Book";

import logo from "../../images/logo/logo-finpec-horizontal-branco.png";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse } from "@mui/material";
import { redirect, useNavigate } from "react-router-dom";
import { useAppStatus } from "../../hooks/app";
import { useAuth } from "../../hooks/auth";
import { GetToken } from '../../services/apiBase'
import { axios} from 'axios'

const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  //minWidth: '300px',
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `70px`,
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  minWidth: "300px",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  backgroundColor: "#000",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer() {
  const theme = useTheme();
  const [openCprColapse, setCprColapse] = React.useState(false);
  const [openBusinessColapse, setBusinessColapse] = React.useState(false);
  const [openB3Colapse, setB3Colapse] = React.useState(false);
  const [openCommunicationColapse, setCommunicationColapse] =
    React.useState(false);
  const [openTicketsColapse, setTicketsColapse] = React.useState(false);
  const [openFinancialColapse, setFinancialColapse] = React.useState(false);
  const [openIndicatorColapse, setIndicatorColapse] = React.useState(false);
  const [openDocumentsColapse, setDocumentsColapse] = React.useState(false);

  const { toggleDrawer, openDrawer, summarization, ticketSummarization } =
    useAppStatus();

  const { user } = useAuth();

  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    toggleDrawer(true);
  };

  const handleDrawerClose = () => {
    toggleDrawer(false);
    setCprColapse(false);
    setBusinessColapse(false);
    setCommunicationColapse(false);
    setTicketsColapse(false);
    setFinancialColapse(false);
    setIndicatorColapse(false);
  };

  const showMenu = (routeName) => {
    if (!user.hasOwnProperty("routes")) return true;

    if (user.routes.length === 0) return true;

    return user.routes.includes(routeName);
  };

  const handleOpenColapse = (mode) => {
    toggleDrawer(true);
  };

  const showSummarization = (count) => {
    return (
      <Box
        sx={{
          backgroundColor: "#e9e9e9",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: "4px",
          paddingRight: "4px",
          minWidth: "30px",
          minHeight: "30px",
        }}
      >
        <Typography sx={{ color: "#1F7DB6", fontWeight: 500 }}>
          {count}
        </Typography>
      </Box>
    );
  };

  const openSwagger = async (project) => {
    const token = GetToken();
    const url = `${process.env.REACT_APP_API_URL}/${project}/api-docs?token=${token}`;
    window.open(url, '_blank')
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={openDrawer}>
        <Toolbar sx={{ backgroundColor: "black" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box sx={{ display: "flex" }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{
                  marginRight: 5,
                  ...(openDrawer && { display: "none" }),
                }}
              >
                <MenuIcon />
              </IconButton>
              <Box
                sx={{
                  display: "flex",
                  height: "40px",
                }}
              >
                <img src={logo} alt="logo" />
              </Box>
            </Box>

            <Box>
              <SimpleDialogDemo />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={openDrawer}>
        <DrawerHeader>
          <IconButton sx={{color: "#fff"}} onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>

        <Divider />

        <List>
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() =>
                handleOpenColapse(true, setCprColapse(!openCprColapse))
              }
              sx={{
                minHeight: 48,
                justifyContent: openDrawer ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: openDrawer ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <PaymentsIcon />
              </ListItemIcon>
              <ListItemText
                primary={"CPRF's"}
                sx={{ opacity: openDrawer ? 1 : 0 }}
              />
              {openDrawer && (openCprColapse ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            <Collapse in={openCprColapse} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {showMenu("cprf/geradas") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/geradas");
                    }}
                  >
                    <ListItemText
                      primary={"Geradas"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(summarization?.total?.gerada)}
                  </ListItemButton>
                )}

                {showMenu("cprf/ativas") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/ativas");
                    }}
                  >
                    <ListItemText
                      primary={"Ativas"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(summarization?.total?.ativa)}
                  </ListItemButton>
                )}

                {showMenu("cprf/antecipacoes") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/antecipacoes");
                    }}
                  >
                    <ListItemText
                      primary={"Antecipações"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(summarization?.total?.antecipacao)}
                  </ListItemButton>
                )}

                {showMenu("cprf/aguardando-decisao") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/aguardando-decisao");
                    }}
                  >
                    <ListItemText
                      primary={"Aguardando Decisão"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(summarization?.total?.resgate_aguardando ?? summarization?.total?.resgate)}
                  </ListItemButton>
                )}

                {showMenu("cprf/renovacao") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/renovacao");
                    }}
                  >
                    <ListItemText
                      primary={"Renovação Pendente"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(summarization?.total?.renovacao)}
                  </ListItemButton>
                )}

                {showMenu("cprf/resgate") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/resgate");
                    }}
                  >
                    <ListItemText
                      primary={"Resgate Confirmado"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(summarization?.total?.resgate_confirmado ?? 0)}
                  </ListItemButton>
                )}

                {showMenu("cprf/opportunity") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/opportunity");
                    }}
                  >
                    <ListItemText
                      primary={"Oportunidades"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("cprf/historic") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/historic");
                    }}
                  >
                    <ListItemText
                      primary={"Histórico"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("cprf/newCpr") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/newCpr");
                    }}
                  >
                    <ListItemText
                      primary={"Nova CPR"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                { /** B3 */}
                {showMenu("cprf/pendentesAssinatura") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("cprf/pendentesAssinatura");
                    }}
                  >
                    <ListItemText
                      primary={"Pendentes de assinatura"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}
              </List>
            </Collapse>
          </ListItem>

          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() =>
                handleOpenColapse(true, setB3Colapse(!openB3Colapse))
              }
              sx={{
                minHeight: 48,
                justifyContent: openDrawer ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: openDrawer ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <AccountBalanceIcon />
              </ListItemIcon>
              <ListItemText
                primary={"B3"}
                sx={{ opacity: openDrawer ? 1 : 0 }}
              />
              {openDrawer && (openB3Colapse ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            <Collapse in={openB3Colapse} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {showMenu("b3/monitoringB3/index") && (
                  

                    <Collapse
                      in={openB3Colapse}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          sx={{ pl: 8 }}
                          onClick={() => {
                            navigate("cprf/acompanhamento_B3");
                          }}
                        >
                          <ListItemText
                            primary={"Acompanhamento B3"}
                            sx={{ opacity: openDrawer ? 1 : 0 }}
                          />
                          {showSummarization(summarization?.b3?.pendente)}
                        </ListItemButton>
                      </List>
                    </Collapse>
                )}
                {showMenu("b3/monitoringB3/index") && (
                  

                    <Collapse
                      in={openB3Colapse}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          sx={{ pl: 8 }}
                          onClick={() => {
                            navigate("cprf/historico_B3");
                          }}
                        >
                          <ListItemText
                            primary={"Histórico B3"}
                            sx={{ opacity: openDrawer ? 1 : 0 }}
                          />
                          
                        </ListItemButton>
                      </List>
                    </Collapse>
                )}
              </List>
            </Collapse>
          </ListItem>

          {showMenu("politicas-comerciais") && (
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                onClick={() =>
                  handleOpenColapse(
                    true,
                    setBusinessColapse(!openBusinessColapse)
                  )
                }
                sx={{
                  minHeight: 48,
                  justifyContent: openDrawer ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: openDrawer ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <MediationIcon />
                </ListItemIcon>
                <ListItemText
                  primary={"Políticas Comerciais"}
                  sx={{ opacity: openDrawer ? 1 : 0 }}
                />
                {openDrawer &&
                  (openBusinessColapse ? <ExpandLess /> : <ExpandMore />)}
              </ListItemButton>

              <Collapse in={openBusinessColapse} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {showMenu("politicas-comerciais/category") && (
                    <ListItemButton
                      sx={{ pl: 8 }}
                      onClick={() => {
                        navigate("politicas-comerciais/category");
                      }}
                    >
                      <ListItemText
                        primary={"Por categoria"}
                        sx={{ opacity: openDrawer ? 1 : 0 }}
                      />
                    </ListItemButton>
                  )}

                  {showMenu("politicas-comerciais/byCpf") && (
                    <ListItemButton
                      sx={{ pl: 8 }}
                      onClick={() => {
                        navigate("politicas-comerciais/byCpf");
                      }}
                    >
                      <ListItemText
                        primary={"Por CPF"}
                        sx={{ opacity: openDrawer ? 1 : 0 }}
                      />
                    </ListItemButton>
                  )}

                  {showMenu("politicas-comerciais/promoCodes") && (
                    <ListItemButton
                      sx={{ pl: 8 }}
                      onClick={() => {
                        navigate("politicas-comerciais/promoCodes");
                      }}
                    >
                      <ListItemText
                        primary={"Códigos promocionais"}
                        sx={{ opacity: openDrawer ? 1 : 0 }}
                      />
                    </ListItemButton>
                  )}
                </List>
              </Collapse>
            </ListItem>
          )}

          {showMenu("branches") && (
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                onClick={() => {
                  navigate("branches");
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: openDrawer ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: openDrawer ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <StoreIcon />
                </ListItemIcon>
                <ListItemText
                  primary={"Filiais"}
                  sx={{ opacity: openDrawer ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          )}

          {showMenu("workSheets") && (
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                onClick={() => {
                  navigate("workSheets");
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: openDrawer ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: openDrawer ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <ListAltIcon />
                </ListItemIcon>
                <ListItemText
                  primary={"Planilhas"}
                  sx={{ opacity: openDrawer ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          )}
          {showMenu("clientList") && (
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                onClick={() => {
                  navigate("clientList");
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: openDrawer ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: openDrawer ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <GroupIcon />
                </ListItemIcon>
                <ListItemText
                  primary={"Clientes"}
                  sx={{ opacity: openDrawer ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          )}

          {showMenu("communication/push-notification") && (
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                onClick={() =>
                  handleOpenColapse(
                    true,
                    setCommunicationColapse(!openCommunicationColapse)
                  )
                }
                sx={{
                  minHeight: 48,
                  justifyContent: openDrawer ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: openDrawer ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <ForumIcon />
                </ListItemIcon>
                <ListItemText
                  primary={"Comunicação"}
                  sx={{ opacity: openDrawer ? 1 : 0 }}
                />
                {openDrawer &&
                  (openCommunicationColapse ? <ExpandLess /> : <ExpandMore />)}
              </ListItemButton>

              <Collapse
                in={openCommunicationColapse}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("communication/push-notification");
                    }}
                  >
                    <ListItemText
                      primary={"Push notifications"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                </List>
              </Collapse>
            </ListItem>
          )}

          {showMenu("sentinels") && (
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                onClick={() => {
                  navigate("sentinels");
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: openDrawer ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: openDrawer ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <SatelliteAltIcon />
                </ListItemIcon>
                <ListItemText
                  primary={"Sentinelas"}
                  sx={{ opacity: openDrawer ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          )}
        </List>

        {showMenu("ticket") && (
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() =>
                handleOpenColapse(true, setTicketsColapse(!openTicketsColapse))
              }
              sx={{
                minHeight: 48,
                justifyContent: openDrawer ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: openDrawer ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <ConfirmationNumberIcon />
              </ListItemIcon>
              <ListItemText
                primary={"Tickets"}
                sx={{ opacity: openDrawer ? 1 : 0 }}
              />
              {openDrawer &&
                (openTicketsColapse ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            <Collapse in={openTicketsColapse} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {showMenu("ticket/renovacao/listaTickets") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("ticket/renovacao/listaTickets");
                    }}
                  >
                    <ListItemText
                      primary={"Renovação"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(ticketSummarization?.ticketsRenovacao)}
                  </ListItemButton>
                )}

                {showMenu("ticket/saldoConta/listaTickets") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("ticket/saldoConta/listaTickets");
                    }}
                  >
                    <ListItemText
                      primary={"Saldo em conta"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(ticketSummarization?.ticketsSaldoConta)}
                  </ListItemButton>
                )}

                {showMenu("ticket/cancelamento/listaTickets") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("ticket/cancelamento/listaTickets");
                    }}
                  >
                    <ListItemText
                      primary={"Cancelamentos"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                    {showSummarization(ticketSummarization?.cancelTickets)}
                  </ListItemButton>
                )}
              </List>
            </Collapse>
          </ListItem>
        )}

        {showMenu("financeiro") && (
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() =>
                handleOpenColapse(
                  true,
                  setFinancialColapse(!openFinancialColapse)
                )
              }
              sx={{
                minHeight: 48,
                justifyContent: openDrawer ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: openDrawer ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <CurrencyExchangeIcon />
              </ListItemIcon>
              <ListItemText
                primary={"Financeiro"}
                sx={{ opacity: openDrawer ? 1 : 0 }}
              />
              {openDrawer &&
                (openFinancialColapse ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            <Collapse in={openFinancialColapse} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {showMenu("financeiro/jurosPassivo") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("financeiro/jurosPassivo");
                    }}
                  >
                    <ListItemText
                      primary={"Juros Passivo"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("financeiro/accummulated") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("financeiro/accummulated");
                    }}
                  >
                    <ListItemText
                      primary={"Acumulado do dia"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("financeiro/liquidateCupons") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("financeiro/liquidateCupons");
                    }}
                  >
                    <ListItemText
                      primary={"Liquidação"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("financeiro/relatorioDiario") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("financeiro/relatorioDiario");
                    }}
                  >
                    <ListItemText
                      primary={"Relatório diário"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("financeiro/searchCupons") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("financeiro/searchCupons");
                    }}
                  >
                    <ListItemText
                      primary={"Buscar cupom"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("financeiro/reports") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("financeiro/reports");
                    }}
                  >
                    <ListItemText
                      primary={"Relatórios"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}
              </List>
            </Collapse>
          </ListItem>
        )}

        {showMenu("indicators") && (
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() =>
                handleOpenColapse(
                  true,
                  setIndicatorColapse(!openIndicatorColapse)
                )
              }
              sx={{
                minHeight: 48,
                justifyContent: openDrawer ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: openDrawer ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <PercentIcon />
              </ListItemIcon>
              <ListItemText
                primary={"Indicadores"}
                sx={{ opacity: openDrawer ? 1 : 0 }}
              />
              {openDrawer &&
                (openIndicatorColapse ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            <Collapse in={openIndicatorColapse} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {showMenu("indicators/financialIndicators") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("indicators/financialIndicators", {
                        state: { table: "CDI_FUTURO" },
                      });
                    }}
                  >
                    <ListItemText
                      primary={"CDI"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("indicators/financialIndicators") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("indicators/financialIndicators", {
                        state: { table: "IPCA_FUTURO" },
                      });
                    }}
                  >
                    <ListItemText
                      primary={"IPCA"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("indicators/financialIndicators") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("indicators/financialIndicators", {
                        state: { table: "REPORTS" },
                      });
                    }}
                  >
                    <ListItemText
                      primary={"Reports"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}

                {showMenu("indicators/boiGordoDatAgro") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={() => {
                      navigate("indicators/boiGordoDatAgro", {
                        state: { table: "REPORTS" },
                      });
                    }}
                  >
                    <ListItemText
                      primary={"Boi Gordo"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}
              </List>
            </Collapse>
          </ListItem>
        )}

        {showMenu("documents") && (
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() =>
                handleOpenColapse(
                  true,
                  setDocumentsColapse(!openDocumentsColapse)
                )
              }
              sx={{
                minHeight: 48,
                justifyContent: openDrawer ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: openDrawer ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <BookIcon />
              </ListItemIcon>
              <ListItemText
                primary={"Documentos"}
                sx={{ opacity: openDrawer ? 1 : 0 }}
              />
              {openDrawer &&
                (openDocumentsColapse ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            <Collapse in={openDocumentsColapse} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {showMenu("documents/apiFinancial") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={
                      () => openSwagger("financial")
                    }
                  >
                    <ListItemText
                      primary={"API Financial"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}
              </List>
            </Collapse>

            <Collapse in={openDocumentsColapse} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {showMenu("documents/apiSubscription") && (
                  <ListItemButton
                    sx={{ pl: 8 }}
                    onClick={
                      () => openSwagger("subscription")
                    }
                  >
                    <ListItemText
                      primary={"API Subscription"}
                      sx={{ opacity: openDrawer ? 1 : 0 }}
                    />
                  </ListItemButton>
                )}
              </List>
            </Collapse>
          </ListItem>
        )}
      </Drawer>
    </Box>
  );
}
